/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_info_usage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage data — We collect information about how you interact with our tools, including pages visited, features used, and time spent.`)
};

const es_privacy_info_usage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos de uso — Recopilamos información sobre cómo interactúas con nuestras herramientas, incluyendo páginas visitadas, funciones utilizadas y tiempo de uso.`)
};

const de_privacy_info_usage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsdaten — Wir erfassen Informationen darüber, wie Sie mit unseren Werkzeugen interagieren, einschließlich besuchter Seiten, genutzter Funktionen und Verweildauer.`)
};

const nl_privacy_info_usage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruiksgegevens — We verzamelen informatie over hoe u met onze tools omgaat, inclusief bezochte pagina's, gebruikte functies en bestede tijd.`)
};

const fr_privacy_info_usage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données d’utilisation — Nous collectons des informations sur la façon dont vous interagissez avec nos outils, y compris les pages visitées, les fonctionnalités utilisées et le temps passé.`)
};

const it_privacy_info_usage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati di utilizzo — Raccogliamo informazioni su come interagisci con i nostri strumenti, incluse le pagine visitate, le funzionalità utilizzate e il tempo trascorso.`)
};

const pt_br2_privacy_info_usage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados de uso — Coletamos informações sobre como você interage com nossas ferramentas, incluindo páginas visitadas, recursos usados e tempo gasto.`)
};

const pt_privacy_info_usage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados de utilização — Recolhemos informação sobre como interage com as nossas ferramentas, incluindo páginas visitadas, funcionalidades utilizadas e tempo despendido.`)
};

const ja_privacy_info_usage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用データ — ツールの利用状況に関する情報を収集します。訪問したページ、使用した機能、滞在時間など。`)
};

const zh_privacy_info_usage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用数据 — 我们收集您与我们工具互动方式的信息，包括访问的页面、使用的功能和花费的时间。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_info_usage = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_info_usage(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_info_usage", locale)
	if (locale === "en") return en_privacy_info_usage(inputs)
	if (locale === "es") return es_privacy_info_usage(inputs)
	if (locale === "de") return de_privacy_info_usage(inputs)
	if (locale === "nl") return nl_privacy_info_usage(inputs)
	if (locale === "fr") return fr_privacy_info_usage(inputs)
	if (locale === "it") return it_privacy_info_usage(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_info_usage(inputs)
	if (locale === "pt") return pt_privacy_info_usage(inputs)
	if (locale === "ja") return ja_privacy_info_usage(inputs)
	return zh_privacy_info_usage(inputs)
};